import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1949710")

_pushScopeId("data-v-f1949710")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "パスワード変更", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("パスワード変更")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit_box = _resolveComponent("icon-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_icon_edit_box, {
        class: "login-edit-box",
        icon: "lock",
        title: "現在のパスワード",
        placeholder: "現在のパスワード",
        inputType: "password",
        modelValue: _ctx.oldPassword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.oldPassword = $event)),
        validation: _ctx.submitted ? _ctx.oldPasswordError : undefined
      }, null, 8, ["modelValue", "validation"]),
      _createVNode(_component_icon_edit_box, {
        class: "login-edit-box",
        icon: "lock",
        title: "新しいパスワード",
        placeholder: "新しいパスワード",
        inputType: "password",
        modelValue: _ctx.newPassword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPassword = $event)),
        validation: _ctx.submitted ? _ctx.newPasswordError : undefined
      }, null, 8, ["modelValue", "validation"]),
      _createVNode(_component_icon_edit_box, {
        class: "login-edit-box",
        icon: "lock",
        title: "新しいパスワード",
        placeholder: "新しいパスワード(確認のため同じものを入力してください)",
        inputType: "password",
        modelValue: _ctx.confirmedNewPassword,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmedNewPassword = $event)),
        validation: _ctx.submitted ? _ctx.confirmedNewPasswordError : undefined
      }, null, 8, ["modelValue", "validation"]),
      _createVNode(_component_normal_button, {
        class: "submit-button",
        state: "normal",
        disabled: _ctx.requesting,
        onClick: _ctx.onSubmitPassword
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
})